import React from 'react'
import { Cell } from 'react-table'
import { Accessor } from 'react-table'
import { ColumnDefinition, ColumnGroupDefinition, TableRowData } from './types'
import { ExtendedColumn } from '../../table'
import { Element } from 'react-bulma-components'

// Fonction utilitaire pour créer une colonne
const createColumn = ({
  header,
  accessor,
  className,
  shouldMerge,
  render,
  id,
}: {
  header: React.ReactNode
  accessor?: keyof TableRowData | Accessor<TableRowData>
  className?: string | (() => string)
  shouldMerge?: boolean
  render?: (data: TableRowData) => React.ReactNode
  id: string
}): ExtendedColumn<TableRowData> => {
  const column: ExtendedColumn<TableRowData> = {
    Header: <Element mt={1}>{header}</Element>,
    ...(accessor && { accessor }),
    ...(render && { Cell: renderCell(render) }),
    id,
  } as ExtendedColumn<TableRowData>

  if (className) {
    column.className = typeof className === 'function' ? className() : className
  }

  if (shouldMerge) {
    column.isHidden = (cell: Cell<TableRowData>) =>
      !cell.row.original.rowGroupOptions.isFirstMission
    column.getRowSpan = (cell: Cell<TableRowData>, data: TableRowData[]) => {
      if (!cell.row.original.rowGroupOptions.isFirstMission) return 1
      return cell.row.original.rowGroupOptions.rowSpan
    }
  }

  return column
}

export const createColumns = (columns: ColumnDefinition[]) => {
  return columns.filter(column => !column.isHidden).map(column => createColumn(column))
}

export const renderCell = (
  render: (data: TableRowData) => React.ReactNode,
): React.FC<{ cell: Cell<TableRowData> }> => {
  return ({ cell }: { cell: Cell<TableRowData> }) => (
    <Element style={{ whiteSpace: 'nowrap' }} display="flex" alignItems="center">
      {render(cell.row.original)}
    </Element>
  )
}

export const addColumnGroup = (
  columns: ExtendedColumn<TableRowData>[],
  group: ColumnGroupDefinition,
): void => {
  columns.push({
    Header: group.Header,
    id: group.id,
    className: group.className,
    columns: group.columns,
  })
}
